export enum ChargeCalculation {
    Fixed = "Fixed",
    Percentage = "Percentage"
}